import C from '../../../../../utilities/constants'
import BidWinningLabel from '@components/ItemPage/Details/Important/Status/Winning'
import Losing from '@components/ItemPage/Details/Important/Status/Losing'

const {
  STATUS: { WON, WINNING, OUTBID, LOST, SOLD, CLOSED },
} = C

const BID_STATUS: any = {
  [WON]: <BidWinningLabel>Won</BidWinningLabel>,
  [WINNING]: <BidWinningLabel />,
  [OUTBID]: <Losing />,
  [LOST]: <Losing>Lost</Losing>,
  [SOLD]: <Losing>Sold</Losing>,
  [CLOSED]: (
    <Losing>
      <span className="font-bold text-base">
        This item is no longer available.
      </span>
    </Losing>
  ),
}

const Status = ({ bidStatus, itemClosed, itemRemoved }: any) => {
  if (!bidStatus) {
    if (itemClosed) return <div>{BID_STATUS[SOLD]}</div>
    if (itemRemoved) return <div>{BID_STATUS[CLOSED]}</div>
    else return <></>
  }
  return <div>{BID_STATUS[bidStatus]}</div>
}

export default Status
